<template>
  <b-row>
    <b-col cols="12">
      <AnggotaDetails />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import AnggotaDetails from "./TableAnggotaDetails.vue";

export default {
  components: {
    BRow,
    BCol,

    AnggotaDetails,
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
